import { createAction, } from 'redux-actions';
import { Api } from '../../api/api';
import { fetchSubmitForm, fetchSubmitFormFailed, fetchSubmitFormSuccess } from "../common/submitForm";
import { logout } from './login';
import {getSelectedLanguage} from "../common/localization";

//- Actions
export const onRegisterSuccess = () => (dispatch) => {
    dispatch(logout());
    dispatch(fetchSubmitFormSuccess());
};
export const onRegisterApplicant = createAction(
    'FETCH_REGISTER_APPLICANT',
    (language, data) => Api.registerApplicant(language, data),
    () => ({
        apiCall: true,
        onSuccess: onRegisterSuccess,
        onFail: fetchSubmitFormFailed
    })
);

export const fetchRegisterApplicant = (data) => (dispatch, getState) => {
    dispatch(fetchSubmitForm());
    dispatch(onRegisterApplicant(getSelectedLanguage(getState()), data));
};



// WEBPACK FOOTER //
// ./src/reducers/account/createAccount.js